import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ott-platform-movies-area ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "section-title d-flex justify-content-between align-items-center flex-wrap",
  "data-cues": "zoomOut"
}
const _hoisted_4 = { class: "ott-platform-movies-card" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ott-platform-movies-card" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-white" }, "أحدث الأفلام والمسلسلات (VOD)", -1)),
        _createVNode(_component_RouterLink, {
          to: "/channel-list",
          class: "btn"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "border-style" }, "عرض الكل", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Swiper, {
      modules: _ctx.modules,
      "slides-per-view": 1,
      "space-between": 10,
      loop: true,
      speed: 18000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      keyboard: { enabled: true, onlyInViewport: false },
      class: "ott-platform-movies-1 mb-2",
      breakpoints: _ctx.breakpoints1
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movies1, (movie, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: movie,
                  alt: "image"
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules", "breakpoints"]),
    _createVNode(_component_Swiper, {
      modules: _ctx.modules,
      "slides-per-view": 1,
      "space-between": 10,
      loop: true,
      speed: 18000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      keyboard: { enabled: true, onlyInViewport: false },
      dir: "rtl",
      class: "ott-platform-movies-2",
      breakpoints: _ctx.breakpoints2
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movies2, (movie, index) => {
          return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: movie,
                  alt: "image"
                }, null, 8, _hoisted_7)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["modules", "breakpoints"])
  ]))
}